export default "__VITE_ASSET__RsshQvxs__"